import React, { useState } from "react";

const TrackingTableRow = (props) => {

    const [showDetails, setShowDetails] = useState(false);

    const toggleDetails = () => {
        setShowDetails(!showDetails);
    }

    const detailsTable = props.details.sort((a,b) => new Date(a.date_created) - new Date(b.date_created)).map( (detail, index, arr) => {
        var dt = new Date(detail.date_created);
        var cumSum = arr.filter((v, i) => i < index).reduce((total, d, idx) => props.free_monthly_content > idx ? total : total + d.charged, 0);
        console.log('*** SP', cumSum, arr);
        return (
            (cumSum > props.payment_cap_amount || props.free_monthly_content > index)
              ? <tr key={detail.content_hash}>
                  <td>{dt.getMonth() + 1}/{dt.getDate()}/{dt.getFullYear()}</td>
                  <td style={{width:"260px"}}><a href={detail.content_hash} rel="noopener noreferrer" target="_blank">{decodeURIComponent(detail.title).substr(0, 30)}{decodeURIComponent(detail.title).length > 30 ? "..." : ""}</a></td>
                  <td className="text-right">{detail.percent_consumed}%</td>
                  <td className="text-right" data-savings={detail.charged}>FREE</td>
              </tr>
              : cumSum + detail.charged > props.payment_cap_amount
                ?
                  <>
                      <tr key={detail.content_hash}>
                          <td>{dt.getMonth() + 1}/{dt.getDate()}/{dt.getFullYear()}</td>
                          <td style={{width:"260px"}}><a href={detail.content_hash} rel="noopener noreferrer" target="_blank">{decodeURIComponent(detail.title).substr(0, 30)}{decodeURIComponent(detail.title).length > 30 ? "..." : ""}</a></td>
                          <td className="text-right">{(detail.percent_consumed * (1 - ((props.payment_cap_amount - cumSum) / detail.charged))).toFixed(0)}%</td>
                          <td className="text-right" data-savings={detail.charged - (props.payment_cap_amount - cumSum)}>FREE</td>
                      </tr>
                      <tr key={detail.content_hash}>
                          <td>{dt.getMonth() + 1}/{dt.getDate()}/{dt.getFullYear()}</td>
                          <td style={{width:"260px"}}><a href={detail.content_hash} rel="noopener noreferrer" target="_blank">{decodeURIComponent(detail.title).substr(0, 30)}{decodeURIComponent(detail.title).length > 30 ? "..." : ""}</a></td>
                          <td className="text-right">{(detail.percent_consumed * ((props.payment_cap_amount - cumSum) / detail.charged)).toFixed(0)}%</td>
                          <td className="text-right">${(props.payment_cap_amount - cumSum).toFixed(2)}</td>
                      </tr>
                  </>
                  : <tr key={detail.content_hash}>
                      <td>{dt.getMonth() + 1}/{dt.getDate()}/{dt.getFullYear()}</td>
                      <td style={{width:"260px"}}><a href={detail.content_hash} rel="noopener noreferrer" target="_blank">{decodeURIComponent(detail.title).substr(0, 30)}{decodeURIComponent(detail.title).length > 30 ? "..." : ""}</a></td>
                      <td className="text-right">{detail.percent_consumed}%</td>
                      <td className="text-right">${detail.charged.toFixed(2)}</td>
                  </tr>);
    }).reverse();

  
    return (<>
        <tr className="domain-row" onClick={() => toggleDetails()}>
          <td style={{width:"90px"}}>
            <div className="flag">
              <img style={{width:"60px"}} src={props.favicon_url} alt="business logo" />
            </div>
          </td>
          <td>{props.name}</td>
          <td className="text-right">{props.details.length}</td>
          {props.payment_cap_active && props.payment_cap_amount < props.total_charged 
            ? <td className="text-right"><span style={{textDecoration:"line-through"}}>${props.total_charged.toFixed(2)}</span> ${props.payment_cap_amount.toFixed(2)}</td>
            : <td className="text-right">${props.total_charged.toFixed(2)}</td> }
          
        </tr>
        {showDetails ? detailsTable : <></> }
            
        
    </>);

}
export default TrackingTableRow;

